import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import HomePage from "./pages/HomePage";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound";
import LoginDashboard from "./pages/LoginDashboard";
import Profiles from "./components/Profiles";
// import MembershipPlans from "./components/MembershipPlans";
import Contact from "./components/Contact";
import ProfileDetails from "./components/ProfileDetails";
import ProfilePage from "./pages/ProfilePage";
import Register from "./pages/RegistrationForm1";
import AdminApp from "./admin/App";
import PaymentPage from "./pages/PaymentPage";
import { SubscriptionProvider} from "./components/SubscriptionContext";
import Pricing from "./components/Pricing";
import PrivateRoute from "./components/PrivateRoute"; 
import ScrollToTop from "./components/ScrollToTop";

// 👇 Private route wrapper based on subscription

function App() {
  return (
    <SubscriptionProvider>
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/payment/:id" element={<PaymentPage />} />
          <Route path="/create-profile" element={<Register />} />
          <Route path="/loginProfile" element={<LoginDashboard />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/profilePage" element={<ProfilePage />} />
          <Route path="/profileDetails/:id" element={<ProfileDetails />} />
          <Route path="/login" element={<Login />} />

          {/* ✅ Protected route: only accessible if subscribed */}
          <Route path="/profiles" element={ <PrivateRoute> <Profiles /> </PrivateRoute>}/>

          <Route path="/index" element={<Navigate to="/home" />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/admin/*" element={<AdminApp />} />
        </Routes>
      </div>
    </Router>
    </SubscriptionProvider>
  );
}

export default App;
